import { apiGet } from '../../api'

export const all_applications = query => {
  return apiGet({
    endpoint: 'application/all_applications?' + query
  })
}
